import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "tagsList", "hiddenFields"];

  connect() {
    this.tags = this.getCurrentTags();
  }

  getCurrentTags() {
    const tags = [];
    this.tagsListTarget.querySelectorAll("[data-tag]").forEach((el) => {
      tags.push(el.dataset.tag);
    });
    return tags;
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.addTag();
    }
  }

  addTag() {
    const input = this.inputTarget;
    const tagValue = input.value.trim();

    if (tagValue && !this.tags.includes(tagValue)) {
      this.tags.push(tagValue);
      this.renderTag(tagValue);
      this.addHiddenField(tagValue);
      input.value = "";
    }
  }

  removeTag(event) {
    const tagElement = event.target.closest("[data-tag]");
    if (!tagElement) return;

    const tagValue = tagElement.dataset.tag;
    this.tags = this.tags.filter((t) => t !== tagValue);

    // Remove the visual tag
    tagElement.remove();

    // Remove the hidden field
    this.removeHiddenField(tagValue);
  }

  renderTag(tagValue) {
    const tagHtml = `
      <span class="inline-flex gap-1 items-center px-2 py-1 text-xs font-medium text-blue-800 bg-blue-100 rounded-full dark:bg-blue-900 dark:text-blue-300" data-tag="${this.escapeHtml(tagValue)}">
        ${this.escapeHtml(tagValue)}
        <button type="button" data-action="click->tags-input#removeTag" class="ml-0.5 text-blue-600 hover:text-blue-800 dark:text-blue-300 dark:hover:text-blue-100">×</button>
      </span>
    `;
    this.tagsListTarget.insertAdjacentHTML("beforeend", tagHtml);
  }

  addHiddenField(tagValue) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "customer[tags][]";
    input.value = tagValue;
    input.dataset.tagField = tagValue;
    this.hiddenFieldsTarget.appendChild(input);
  }

  removeHiddenField(tagValue) {
    const field = this.hiddenFieldsTarget.querySelector(
      `[data-tag-field="${tagValue}"]`
    );
    if (field) {
      field.remove();
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  }
}
